import { useConfiguratorState } from '../store';
import { useConfiguratorTranslations } from '../translations';
import { resetAutoSelectedStock } from './StockSelector';
import shared from '../configurator.module.scss';

export function VehicleModeChips({
	stockTotal,
	disabled,
}: {
	stockTotal: number;
	disabled: boolean;
}) {
	const vehicleMode = useConfiguratorState((s) => s.vehicleMode);
	const setVehicleMode = useConfiguratorState((s) => s.setVehicleMode);
	const tr = useConfiguratorTranslations();

	return (
		<>
			<div className={shared.filterGroupLabel}>{tr.vehicleModeLabel}</div>
			<div className={`${shared.chipRow} mb-4`}>
				<button
					className={`${shared.chip} ${vehicleMode === 'new' ? shared.chipActive : ''
						}`}
					onClick={() => {
						resetAutoSelectedStock();
						setVehicleMode('new');
					}}
				>
					{tr.vehicleModeNew}
				</button>
				<button
					className={`${shared.chip} ${vehicleMode === 'stock' ? shared.chipActive : ''
						}`}
					disabled={disabled}
					onClick={() => setVehicleMode('stock')}
				>
					{tr.vehicleModeStock(stockTotal)}
				</button>
			</div>
		</>
	);
}
